import { render, staticRenderFns } from "./DigitSpanBackward.vue?vue&type=template&id=17452096&scoped=true&"
import script from "./DigitSpanBackward.vue?vue&type=script&lang=js&"
export * from "./DigitSpanBackward.vue?vue&type=script&lang=js&"
import style0 from "./DigitSpanBackward.vue?vue&type=style&index=0&id=17452096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17452096",
  null
  
)

export default component.exports